// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1r04idpf{inset:0}\n._v56414ka{transition:opacity .22s}._1pby1fw0{z-index:700}\n._kqsw1n9t{position:fixed}", ""]);
// Exports
module.exports = exports;
